export function buildVerifiedRecipientOptions(payload) {
  const rows = Array.isArray(payload)
    ? payload
    : (Array.isArray(payload && payload.data) ? payload.data : []);
  const seen = new Set();

  return rows.reduce((options, recipient) => {
    const email = recipient && typeof recipient.email === 'string'
      ? recipient.email.trim()
      : '';
    const normalizedEmail = email.toLowerCase();

    if (!email || seen.has(normalizedEmail)) return options;

    seen.add(normalizedEmail);
    options.push({ id: email, label: email });
    return options;
  }, []);
}

export function addSelectedRecipients(payload, sendToAccount, selectedRecipients) {
  if (sendToAccount || !Array.isArray(selectedRecipients) || selectedRecipients.length === 0) {
    return payload;
  }

  return {
    ...payload,
    recipients: [...selectedRecipients],
  };
}
